module.exports = __webpack_public_path__ + "img/kendeji.b265e5bb.png";